import React from 'react';
import G6Editor from '@antv/g6-editor';
import './style.less';

class Page extends React.Component {
    createPage(container) {
        return new G6Editor.Flow({
            graph: {
                container,
                height: 420
            },
            align: {
                grid: true
            }
        });
    }

    getCreatePage() {
        const { createPage } = this.props;
        return createPage ? createPage : this.createPage;
    }

    componentDidMount() {
        const { editor } = this.props;
        const createPage = this.getCreatePage();
        const page = createPage(this.pageContainer);
        editor.add(page);
    }

    handleScroll = (e) => {
        console.log(e);
        e.stopPropagation();
    }

    render() {
        return (<div id="screenshots" className="page" onWheel={(e) => this.handleScroll(e)} ref={el => { this.pageContainer = el; }}></div>);
    }
}
export default Page;


// WEBPACK FOOTER //
// ./src/components/common/flowChartCommon/Page.js